/**
 * 微商通路相關路由定義
 *
 * 僅定義與元件有關的內容
 * 其他定義訊息透過API合併
 */

import { routeName } from "../utils";
import pageConfig from "@/config/page";

const name = "tg_business";
const page = pageConfig.pages[name];

export default {
  name: name,
  path: name,
  component: () => import("@/layout/routerView"),
  redirect: { name: routeName("my-team", name) },
  meta: {
    disable: true,
  },
  children: [
    {
      name: routeName("agent.privilege", name),
      path: "agent-privilege",
      redirect: { name: routeName("agent.privilege.index", name) },
      component: () => import("@/layout/routerView"),
      children: [
        {
          name: routeName("agent.privilege.index", name),
          path: "",
          component: page.privilege,
          props: { project: "agent", hasUser: false },
        },
        {
          name: routeName("agent.privilege.user", name),
          path: ":username",
          component: page.privilege,
          props: { project: "agent", hasUser: true },
        },
      ],

      // component: page.privilege,
      // props: { project: "agent" },
      // meta: {
      //   floating: true,
      // },
    },
    {
      name: routeName("member.privilege", name),
      path: "member-privilege",
      component: page.member.privilege,
      props: { project: "member" },
      meta: {
        floating: true,
      },
    },
    {
      name: routeName("member.review", name),
      path: "member-review",
      component: page.member.review,
      meta: {
        floating: true,
      },
    },
    {
      name: routeName('member.board', name),
      path: "member-board",
      component: page.member.board,
    },
    // member reward
    {
      name: routeName("member.reward", name),
      path: "member-reward",
      redirect: { name: routeName("member.reward.index", name) },
      component: () => import("@/layout/routerView"),
      children: [
        {
          name: routeName("member.reward.index", name),
          path: "",
          component: page.member.reward.index,
          props: true,
          meta: {
            floating: true,
          },
        },
        {
          name: routeName("member.reward.games", name),
          path: "games",
          component: page.member.reward.games,
          props: true,
          meta: {
            barsType: "sub",
            floating: true,
          },
        },
        {
          name: routeName("member.reward.detail", name),
          path: "detail/:historyKey",
          component: page.member.reward.detail,
          props: true,
          meta: {
            barsType: "sub",
            floating: true,
          },
        },
      ],
    },
    {
      name: routeName("announcement.review", name),
      path: "announcement-review",
      component: page.announcement.review,
      meta: {
        floating: true,
      },
    },
    {
      path: "my-team",
      name: routeName("my-team", name),
      component: page["my-team"],
      meta: {
        floating: true,
      },
    },
    {
      path: "reward-record",
      name: routeName("reward-record", name),
      redirect: { name: routeName("reward-record.index", name) },
      component: () => import("@/layout/routerView"),
      children: [
        {
          path: "",
          name: routeName("reward-record.index", name),
          component: page["reward-record"].index,
          meta: {
            floating: true,
          },
        },
        {
          path: "member",
          name: routeName("reward-record.member", name),
          component: page["reward-record"].users,
          meta: {
            barsType: "sub",
            floating: true,
          },
        },
        {
          path: "member/:username",
          name: routeName("reward-record.member.detail", name),
          component: page["reward-record"].detail,
          props: true,
          meta: {
            barsType: "sub",
            floating: true,
          },
        },
      ],
    },
    {
      name: routeName("level-distributed", name),
      path: "level-distributed",
      redirect: { name: routeName("level-distributed.index", name) },
      component: () => import("@/layout/routerView"),
      children: [
        {
          name: routeName("level-distributed.index", name),
          path: "",
          component: page["level-distributed"].index,
          props: { hasUser: false },
        },
        {
          name: routeName("level-distributed.user", name),
          path: ":username",
          component: page["level-distributed"].index,
          props: { hasUser: true },
        },
      ],
    },
    {
      name: routeName('accounting', name),
      path: "accounting",
      component: page.accounting,
    },
    {
      name: routeName('bet_ranking', name),
      path: "bet_ranking",
      component: page.ranking.bet_ranking,
      meta: {
        floating: true,
      },
    }
  ],
};
